exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-3051bb72]{border:1px solid #ececec;text-align:center;padding:.16rem .1rem}a[data-v-3051bb72]{word-break:break-all;cursor:pointer}b[data-v-3051bb72]{font-weight:700;color:#151515}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3051bb72","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/landingPage/hwPolicy.vue
// module id = 638
// module chunks = 19